var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        "background-color": "#003333",
        color: "#ffffff",
        padding: "20px 0"
      }
    },
    [
      _c(
        "el-col",
        {
          staticClass: "text-style",
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { span: 24 }
        },
        [
          _c("span", [
            _vm._v("If you have any questions, feel free to email us")
          ]),
          _vm._v(" "),
          _c("el-divider", {
            staticStyle: { padding: "0 5px" },
            attrs: { direction: "vertical" }
          }),
          _vm._v(" "),
          _c("span", [
            _c("a", { attrs: { href: "mailto:team@unifiproperty.com" } }, [
              _vm._v("team@unifiproperty.com")
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22c98b19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c98b19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/contactBannerDark.vue
// module id = null
// module chunks = 